import Vue from 'vue'
import Vuex from 'vuex'
import { Accordion, AccordionItem } from "../../components/Accordion"
import SpeciesVisibility from "../../views/liveaboard/SpeciesVisibility.vue";
import Responsive from '../../components/core/Responsive'

Vue.use(Vuex)

Vue.component('species-visibility', SpeciesVisibility)
Vue.component('accordion', Accordion)
Vue.component('accordion-item', AccordionItem)
Vue.component('responsive', Responsive)

const apps = document.querySelectorAll('.vue-app');

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
